import moment from "moment";
export default {
  methods: {
    validationNum: (rule, value, callback) => {
      const reg = /^\d*$/;
      if (!reg.test(value)) {
        return callback(new Error("请输入数字"));
      } else {
        callback();
      }
    },
    validateDateRange(stm, etm) {
      if (moment(stm) > moment(etm)) {
        this.$message({
          message: "开始时间不能大于结束时间",
          type: "error"
        });
        return false;
      }
      return true;
    },
    sort(result, pageNum, pageSize) {
      var list = [];
      for (var key in result) {
        list.push(result[key]);
      }
      list.sort(function(a, b) {
        var ib = parseInt(b["__index"]);
        var ia = parseInt(a["__index"]);
        return ia - ib;
      });
      for (let i = 0; i < list.length; i++) {
        list[i].num = (parseInt(pageNum) - 1) * parseInt(pageSize) + 1 + i;
      }
      return list;
    },
    /* 验证字符串中只包括中文、字母(大小写)、数字
     * egg: rules: {
     *           userNm1: [{ validator: this.validateString, trigger: "blur", required: true, minLength:2, maxLength:10 }],
     *           userNm2: [{ validator: this.validateString, trigger: "blur", required: false, minLength:2, maxLength:10 }],
     *           userNm3: [{ validator: this.validateString, trigger: "blur", required: true}]
     *      }
     * 另外：对于一些禁止输入空格的控件，在控件上直接添加 onkeydown="if(event.keyCode==32) return false"，再配合此方法使用
     */
    validateString(rule, value = '', callback) {
      if (rule.required && !value) return callback(new Error("不能为空"));
      if (!rule.required && (value == null || value.length == 0))
        return callback();
      if (rule.minLength && value.replace(/[\u0391-\uFFE5]/g, "aa").length < rule.minLength)
        return callback(new Error("不能少于" + rule.minLength + "位字符"));
      if (rule.maxLength && value.replace(/[\u0391-\uFFE5]/g, "aa").length > rule.maxLength)
        return callback(new Error("不能多于" + rule.maxLength + "位字符"));

      let reg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
      if (!reg.test(value)) {
        return callback(new Error("请输入中文、字母(大小写)、数字"));
      } else {
        callback();
      }
    },
    /*
    func:去除字符串空格
    param: 
         str（目标字符串）:      必填 
         postion(指定空格位置)： 可选  left/左侧  right/右侧  all/左右
    demo: xxx=this.trimSpace(xxx,'all')
    */
    trimSpace(str = "", positon = "all") {
      str = new String(str);
      if (str) {
        switch (positon) {
          case "left":
            str = str.replace(/^[\s\n\t]+/g, "");
            break;
          case "right":
            str = str.replace(/[\s\n\t]+$/g, "");
            break;
          default:
            str = str.replace(/(^[\s\n\t]+|[\s\n\t]+$)/g, "");
            break;
        }
      }
      return str;
    },

    //获取字符串实际 charLength(字节长度)
    getCharLength(tartgetStr = "") {
      return this.trimSpace(tartgetStr).replace(/[\u0391-\uFFE5]/g, "aa")
        .length;
    },

    /*
  func:自定义数字验证
  验证优先级： required  > maxNum、minNum  >isInt > precision > maxLength/minLength
  required:是否为空
  maxNum/minNum: 最大数字、最小数字
  isInt:           是否是整数 true false
  precision:小数点后位数
  maxLength/minLength:字符串长度最长、最短
  demo: rules:{
          number1:[{validator: this.validateNumber, trigger: "blur", required: true, maxNum:100, minNum:0, precision:2, minLength:2, maxLength:10 }]
        }
   */
    validateNumber(rule, value = "", callback) {
      value = this.trimSpace(value);
      if (rule.required && !value) {
        return callback(new Error("不能为空"));
      }

      if (!rule.required && (value == null || value.length == 0)) {
        return callback();
      }

      if (isNaN(value)) {
        return callback(new Error("输入数字"));
      }

      if (!isNaN(rule.maxNum) && rule.maxNum < Number(value)) {
        return callback(new Error(`最大：${rule.maxNum}`));
      }

      if (!isNaN(rule.minNum) && rule.minNum > Number(value)) {
        return callback(new Error(`最小：${rule.minNum}`));
      }

      if (rule.isInt && !/^-?\d+$/.test(value)) {
        return callback(new Error(`输入整数`));
      }

      if (
        /^\+?[1-9][0-9]*$/.test(rule.precision) &&
        new String(value).indexOf(".") > 0
      ) {
        let len = value.substring(new String(value).indexOf(".") + 1).length;
        if (rule.precision < len) {
          return callback(new Error(`小数点后最多保留${rule.precision}位数字`));
        } else {
          return callback();
        }
      }

      if (rule.minLength && this.getCharLength(value) < rule.minLength) {
        return callback(new Error("不能少于" + rule.minLength + "位字符"));
      }
      if (rule.maxLength && this.getCharLength(value) > rule.maxLength) {
        return callback(new Error("不能多于" + rule.maxLength + "位字符"));
      } else {
        callback();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/common.js